/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Monthly_Billing_NoteInputs */

const tr_landing_pricing_monthly_billing_note = /** @type {(inputs: Landing_Pricing_Monthly_Billing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aylık taahhütsüz`)
};

const en_landing_pricing_monthly_billing_note = /** @type {(inputs: Landing_Pricing_Monthly_Billing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`monthly, no commitment`)
};

const de_landing_pricing_monthly_billing_note = /** @type {(inputs: Landing_Pricing_Monthly_Billing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`monatlich, ohne Bindung`)
};

const ru_landing_pricing_monthly_billing_note = /** @type {(inputs: Landing_Pricing_Monthly_Billing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`помесячно, без обязательств`)
};

/**
* | output |
* | --- |
* | "monthly, no commitment" |
*
* @param {Landing_Pricing_Monthly_Billing_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_monthly_billing_note = /** @type {((inputs?: Landing_Pricing_Monthly_Billing_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Monthly_Billing_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_monthly_billing_note(inputs)
	if (locale === "de") return de_landing_pricing_monthly_billing_note(inputs)
	if (locale === "ru") return ru_landing_pricing_monthly_billing_note(inputs)
	return tr_landing_pricing_monthly_billing_note(inputs)
});